import script from "./TaskBatchStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskBatchStatus.vue?vue&type=script&setup=true&lang=js"

import "./TaskBatchStatus.vue?vue&type=style&index=0&id=a0eb2312&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0eb2312"]])

export default __exports__